module.exports = __webpack_public_path__ + "img/zip-uploaded.9f16ccdd.svg";